<template>
  <div class="tabela-card">
    <div v-if="loading" class="estado-central">
      <v-progress-circular indeterminate color="#023449" size="48"></v-progress-circular>
      <p>Carregando...</p>
    </div>

    <div v-else-if="!totalProdutos" class="estado-central">
      <v-icon size="56" color="#cbd5e1">mdi-inbox</v-icon>
      <p>Nenhum produto encontrado</p>
    </div>

    <div v-else class="table-wrapper">
      <table class="data-table">
        <colgroup>
          <col v-if="modoGrupos" class="col-exp">
          <col class="col-nome">
          <col class="col-data">
          <col class="col-origem">
          <col class="col-val">
          <col class="col-val">
          <col class="col-val">
          <col class="col-pct">
          <col class="col-status">
        </colgroup>

        <thead v-if="modoGrupos">
        <tr class="table-head-group">
          <th colspan="2" class="thg-empty"></th>
          <th colspan="2" class="thg-section thg-section-skus">
            <v-icon x-small class="mr-1" color="#a5f3fc">mdi-tag-multiple-outline</v-icon>
            SKUs
          </th>
          <th colspan="3" class="thg-section thg-section-financeiro">
            <v-icon x-small class="mr-1" color="#6ee7b7">mdi-currency-brl</v-icon>
            Financeiro
          </th>
          <th colspan="2" class="thg-section thg-section-ruptura">
            <v-icon x-small class="mr-1" color="#fda4af">mdi-alert-circle-outline</v-icon>
            Ruptura
          </th>
        </tr>
        <tr class="table-head">
          <th class="th-exp"></th>
          <th class="th-nome">
            <div class="th-header-content">
              <div class="th-inner">
                <v-icon x-small class="th-icon">mdi-label-outline</v-icon>
                <span>Nome</span>
                <div class="indicadores-estado">
                  <v-icon
                      v-if="ordenacaoPorCampo.nome === 'asc'"
                      x-small
                      class="indicador-ordenacao"
                      color="#7c3aed"
                      title="Ordenado ascendente"
                  >
                    mdi-arrow-up
                  </v-icon>
                  <v-icon
                      v-if="ordenacaoPorCampo.nome === 'desc'"
                      x-small
                      class="indicador-ordenacao"
                      color="#7c3aed"
                      title="Ordenado descendente"
                  >
                    mdi-arrow-down
                  </v-icon>
                  <v-icon
                      v-if="filtrosGrupo.nome.length > 0"
                      x-small
                      class="indicador-filtro"
                      color="#f59e0b"
                      title="Filtrado"
                  >
                    mdi-filter
                  </v-icon>
                </div>
              </div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuNome">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosGrupo.nome.length > 0 || ordenacaoPorCampo.nome !== null }"
                  >
                    <v-icon
                        x-small
                        :color="(filtrosGrupo.nome.length > 0 || ordenacaoPorCampo.nome !== null) ? 'white' : 'rgba(255,255,255,0.6)'"
                    >
                      mdi-filter-variant
                    </v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="nome" tipo="texto"
                    :valores="valoresUnicosGrupo('nome')"
                    :filtro-ativo="filtrosGrupo.nome"
                    :ordenacao-ativa="ordenacaoPorCampo.nome"
                    @aplicar="aplicarFiltroGrupo('nome', $event, 'menuNome')"
                    @limpar="limparFiltroGrupo('nome')"
                    @ordenar="aplicarOrdenacao('nome', $event, 'menuNome')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-num text-center">
            <div class="th-header-content">
              <div class="th-inner justify-center"><span>Ativos</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuSkusAtivos">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosGrupo.skus_ativos.min !== null || filtrosGrupo.skus_ativos.max !== null || ordenacaoPorCampo.skus_ativos !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="skus_ativos" tipo="numero"
                    :filtro-ativo="filtrosGrupo.skus_ativos"
                    :ordenacao-ativa="ordenacaoPorCampo.skus_ativos"
                    @aplicar="aplicarFiltroGrupo('skus_ativos', $event, 'menuSkusAtivos')"
                    @limpar="limparFiltroGrupo('skus_ativos')"
                    @ordenar="aplicarOrdenacao('skus_ativos', $event, 'menuSkusAtivos')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-num text-center">
            <div class="th-header-content">
              <div class="th-inner justify-center"><span>Ruptura</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuSkusRuptura">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosGrupo.skus_ruptura.min !== null || filtrosGrupo.skus_ruptura.max !== null || ordenacaoPorCampo.skus_ruptura !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="skus_ruptura" tipo="numero"
                    :filtro-ativo="filtrosGrupo.skus_ruptura"
                    :ordenacao-ativa="ordenacaoPorCampo.skus_ruptura"
                    @aplicar="aplicarFiltroGrupo('skus_ruptura', $event, 'menuSkusRuptura')"
                    @limpar="limparFiltroGrupo('skus_ruptura')"
                    @ordenar="aplicarOrdenacao('skus_ruptura', $event, 'menuSkusRuptura')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-val text-right">
            <div class="th-header-content">
              <div class="th-inner justify-end"><span>Necessidade</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuNecessidade">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosGrupo.necessidade.min !== null || filtrosGrupo.necessidade.max !== null || ordenacaoPorCampo.necessidade !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="necessidade" tipo="moeda"
                    :filtro-ativo="filtrosGrupo.necessidade"
                    :ordenacao-ativa="ordenacaoPorCampo.necessidade"
                    @aplicar="aplicarFiltroGrupo('necessidade', $event, 'menuNecessidade')"
                    @limpar="limparFiltroGrupo('necessidade')"
                    @ordenar="aplicarOrdenacao('necessidade', $event, 'menuNecessidade')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-val text-right">
            <div class="th-header-content">
              <div class="th-inner justify-end"><span>Atendido</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuAtendido">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosGrupo.atendido.min !== null || filtrosGrupo.atendido.max !== null || ordenacaoPorCampo.atendido !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="atendido" tipo="moeda"
                    :filtro-ativo="filtrosGrupo.atendido"
                    :ordenacao-ativa="ordenacaoPorCampo.atendido"
                    @aplicar="aplicarFiltroGrupo('atendido', $event, 'menuAtendido')"
                    @limpar="limparFiltroGrupo('atendido')"
                    @ordenar="aplicarOrdenacao('atendido', $event, 'menuAtendido')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-val text-right">
            <div class="th-header-content">
              <div class="th-inner justify-end"><span>Ruptura (R$)</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuFaltante">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosGrupo.faltante.min !== null || filtrosGrupo.faltante.max !== null || ordenacaoPorCampo.faltante !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="faltante" tipo="moeda"
                    :filtro-ativo="filtrosGrupo.faltante"
                    :ordenacao-ativa="ordenacaoPorCampo.faltante"
                    @aplicar="aplicarFiltroGrupo('faltante', $event, 'menuFaltante')"
                    @limpar="limparFiltroGrupo('faltante')"
                    @ordenar="aplicarOrdenacao('faltante', $event, 'menuFaltante')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-pct text-center">
            <div class="th-header-content">
              <div class="th-inner justify-center"><span>% SKUs</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuPctSkus">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosGrupo.pct_skus.min !== null || filtrosGrupo.pct_skus.max !== null || ordenacaoPorCampo.pct_skus !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="pct_skus" tipo="percentual"
                    :filtro-ativo="filtrosGrupo.pct_skus"
                    :ordenacao-ativa="ordenacaoPorCampo.pct_skus"
                    @aplicar="aplicarFiltroGrupo('pct_skus', $event, 'menuPctSkus')"
                    @limpar="limparFiltroGrupo('pct_skus')"
                    @ordenar="aplicarOrdenacao('pct_skus', $event, 'menuPctSkus')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-pct text-center">
            <div class="th-header-content">
              <div class="th-inner justify-center"><span>% R$</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuPctRs">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosGrupo.pct_rs.min !== null || filtrosGrupo.pct_rs.max !== null || ordenacaoPorCampo.pct_rs !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="pct_rs" tipo="percentual"
                    :filtro-ativo="filtrosGrupo.pct_rs"
                    :ordenacao-ativa="ordenacaoPorCampo.pct_rs"
                    @aplicar="aplicarFiltroGrupo('pct_rs', $event, 'menuPctRs')"
                    @limpar="limparFiltroGrupo('pct_rs')"
                    @ordenar="aplicarOrdenacao('pct_rs', $event, 'menuPctRs')"
                />
              </v-menu>
            </div>
          </th>
        </tr>
        </thead>

        <thead v-else>
        <tr class="table-head-group">
          <th colspan="2" class="thg-empty"></th>
          <th colspan="1" class="thg-empty"></th>
          <th colspan="3" class="thg-section thg-section-financeiro">
            <v-icon x-small class="mr-1" color="#6ee7b7">mdi-currency-brl</v-icon>
            Financeiro
          </th>
          <th colspan="2" class="thg-empty"></th>
        </tr>
        <tr class="table-head">
          <th class="th-nome">
            <div class="th-header-content">
              <div class="th-inner">
                <v-icon x-small class="th-icon">mdi-package-variant-closed</v-icon>
                <span>Produto</span>
                <div class="indicadores-estado">
                  <v-icon v-if="ordenacaoPorCampo.descricao_produto === 'asc'" x-small class="indicador-ordenacao" color="#7c3aed" title="Ordenado ascendente">mdi-arrow-up</v-icon>
                  <v-icon v-if="ordenacaoPorCampo.descricao_produto === 'desc'" x-small class="indicador-ordenacao" color="#7c3aed" title="Ordenado descendente">mdi-arrow-down</v-icon>
                  <v-icon v-if="filtrosProduto.descricao_produto.length > 0" x-small class="indicador-filtro" color="#f59e0b" title="Filtrado">mdi-filter</v-icon>
                </div>
              </div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuDescricaoProduto">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosProduto.descricao_produto.length > 0 || ordenacaoPorCampo.descricao_produto !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="descricao_produto" tipo="texto"
                    :valores="valoresUnicosProduto('descricao_produto')"
                    :filtro-ativo="filtrosProduto.descricao_produto"
                    :ordenacao-ativa="ordenacaoPorCampo.descricao_produto"
                    @aplicar="aplicarFiltroProduto('descricao_produto', $event, 'menuDescricaoProduto')"
                    @limpar="limparFiltroProduto('descricao_produto')"
                    @ordenar="aplicarOrdenacao('descricao_produto', $event, 'menuDescricaoProduto')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-num text-center">
            <div class="th-header-content">
              <div class="th-inner justify-center"><span>Data Mov.</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuDataMovimento">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosProduto.data_movimento.length > 0 || ordenacaoPorCampo.data_movimento !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="data_movimento" tipo="data"
                    :valores="valoresUnicosProduto('data_movimento')"
                    :filtro-ativo="filtrosProduto.data_movimento"
                    :ordenacao-ativa="ordenacaoPorCampo.data_movimento"
                    @aplicar="aplicarFiltroProduto('data_movimento', $event, 'menuDataMovimento')"
                    @limpar="limparFiltroProduto('data_movimento')"
                    @ordenar="aplicarOrdenacao('data_movimento', $event, 'menuDataMovimento')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-origem text-center">
            <div class="th-header-content">
              <div class="th-inner justify-center"><span>Origem</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuOrigem">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosProduto.origem.length > 0 || ordenacaoPorCampo.origem !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="origem" tipo="selecao"
                    :valores="valoresUnicosProduto('origem')"
                    :filtro-ativo="filtrosProduto.origem"
                    :ordenacao-ativa="ordenacaoPorCampo.origem"
                    @aplicar="aplicarFiltroProduto('origem', $event, 'menuOrigem')"
                    @limpar="limparFiltroProduto('origem')"
                    @ordenar="aplicarOrdenacao('origem', $event, 'menuOrigem')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-val text-right">
            <div class="th-header-content">
              <div class="th-inner justify-end"><span>Solicitado</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuCustoSolicitado">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosProduto.custo_solicitado.min !== null || filtrosProduto.custo_solicitado.max !== null || ordenacaoPorCampo.custo_solicitado !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="custo_solicitado" tipo="moeda"
                    :filtro-ativo="filtrosProduto.custo_solicitado"
                    :ordenacao-ativa="ordenacaoPorCampo.custo_solicitado"
                    @aplicar="aplicarFiltroProduto('custo_solicitado', $event, 'menuCustoSolicitado')"
                    @limpar="limparFiltroProduto('custo_solicitado')"
                    @ordenar="aplicarOrdenacao('custo_solicitado', $event, 'menuCustoSolicitado')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-val text-right">
            <div class="th-header-content">
              <div class="th-inner justify-end"><span>Atendido</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuCustoAtendido">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosProduto.custo_atendido.min !== null || filtrosProduto.custo_atendido.max !== null || ordenacaoPorCampo.custo_atendido !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="custo_atendido" tipo="moeda"
                    :filtro-ativo="filtrosProduto.custo_atendido"
                    :ordenacao-ativa="ordenacaoPorCampo.custo_atendido"
                    @aplicar="aplicarFiltroProduto('custo_atendido', $event, 'menuCustoAtendido')"
                    @limpar="limparFiltroProduto('custo_atendido')"
                    @ordenar="aplicarOrdenacao('custo_atendido', $event, 'menuCustoAtendido')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-val text-right">
            <div class="th-header-content">
              <div class="th-inner justify-end"><span>Não Atendido</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuCustoFaltante">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosProduto.custo_faltante.min !== null || filtrosProduto.custo_faltante.max !== null || ordenacaoPorCampo.custo_faltante !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="custo_faltante" tipo="moeda"
                    :filtro-ativo="filtrosProduto.custo_faltante"
                    :ordenacao-ativa="ordenacaoPorCampo.custo_faltante"
                    @aplicar="aplicarFiltroProduto('custo_faltante', $event, 'menuCustoFaltante')"
                    @limpar="limparFiltroProduto('custo_faltante')"
                    @ordenar="aplicarOrdenacao('custo_faltante', $event, 'menuCustoFaltante')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-pct text-center">
            <div class="th-header-content">
              <div class="th-inner justify-center"><span>% Atendido</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuPercentualAtendido">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosProduto.percentual_atendido.min !== null || filtrosProduto.percentual_atendido.max !== null || ordenacaoPorCampo.percentual_atendido !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="percentual_atendido" tipo="percentual"
                    :filtro-ativo="filtrosProduto.percentual_atendido"
                    :ordenacao-ativa="ordenacaoPorCampo.percentual_atendido"
                    @aplicar="aplicarFiltroProduto('percentual_atendido', $event, 'menuPercentualAtendido')"
                    @limpar="limparFiltroProduto('percentual_atendido')"
                    @ordenar="aplicarOrdenacao('percentual_atendido', $event, 'menuPercentualAtendido')"
                />
              </v-menu>
            </div>
          </th>
          <th class="th-status text-center">
            <div class="th-header-content">
              <div class="th-inner justify-center"><span>Status</span></div>
              <v-menu offset-y left :close-on-content-click="false" max-width="320" ref="menuStatusItem">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon x-small v-bind="attrs" v-on="on" class="filter-btn"
                      :class="{ 'filter-active': filtrosProduto.status_principal.length > 0 || ordenacaoPorCampo.status_principal !== null }"
                  >
                    <v-icon x-small>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <filtro-coluna
                    campo="status_principal" tipo="selecao"
                    :valores="valoresUnicosProduto('status_principal')"
                    :filtro-ativo="filtrosProduto.status_principal"
                    :ordenacao-ativa="ordenacaoPorCampo.status_principal"
                    @aplicar="aplicarFiltroProduto('status_principal', $event, 'menuStatusItem')"
                    @limpar="limparFiltroProduto('status_principal')"
                    @ordenar="aplicarOrdenacao('status_principal', $event, 'menuStatusItem')"
                />
              </v-menu>
            </div>
          </th>
        </tr>
        </thead>

        <tbody>
        <template v-for="linha in linhas">

          <tr
              v-if="linha.tipo === 'subheader'"
              :key="`sh-${linha.uid}`"
              class="subheader-row"
          >
            <th class="subh-exp"></th>
            <th class="subh-nome" :style="{ paddingLeft: (linha.nivel * 20 + 8) + 'px' }">
              <div class="subh-header-content">
                <div class="subh-inner justify-start">
                  <span class="subh-label">Produto</span>
                </div>
                <v-menu offset-y left :close-on-content-click="false" max-width="320" :ref="`subMenuDescProd-${linha.uid}`">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon x-small v-bind="attrs" v-on="on"
                        class="filter-btn filter-btn-subh"
                        :class="{ 'filter-active': filtrosProduto.descricao_produto.length > 0 || ordenacaoPorCampo.descricao_produto !== null }"
                    >
                      <v-icon x-small>mdi-filter-variant</v-icon>
                    </v-btn>
                  </template>
                  <filtro-coluna
                      campo="descricao_produto"
                      tipo="texto"
                      :valores="valoresUnicosProdutoDoGrupo(linha.grupoUid, 'descricao_produto')"
                      :filtro-ativo="filtrosProduto.descricao_produto"
                      :ordenacao-ativa="ordenacaoPorCampo.descricao_produto"
                      @aplicar="aplicarFiltroProduto('descricao_produto', $event, `subMenuDescProd-${linha.uid}`)"
                      @limpar="limparFiltroProduto('descricao_produto')"
                      @ordenar="aplicarOrdenacao('descricao_produto', $event, `subMenuDescProd-${linha.uid}`)"
                  />
                </v-menu>
              </div>
            </th>
            <th class="subh-num">
              <div class="subh-header-content">
                <div class="subh-inner justify-center">
                  <span class="subh-label">Data Mov.</span>
                </div>
                <v-menu offset-y left :close-on-content-click="false" max-width="320" :ref="`subMenuDataMov-${linha.uid}`">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon x-small v-bind="attrs" v-on="on"
                        class="filter-btn filter-btn-subh"
                        :class="{ 'filter-active': filtrosProduto.data_movimento.length > 0 || ordenacaoPorCampo.data_movimento !== null }"
                    >
                      <v-icon x-small>mdi-filter-variant</v-icon>
                    </v-btn>
                  </template>
                  <filtro-coluna
                      campo="data_movimento" tipo="data"
                      :valores="valoresUnicosProduto('data_movimento')"
                      :filtro-ativo="filtrosProduto.data_movimento"
                      :ordenacao-ativa="ordenacaoPorCampo.data_movimento"
                      @aplicar="aplicarFiltroProduto('data_movimento', $event, `subMenuDataMov-${linha.uid}`)"
                      @limpar="limparFiltroProduto('data_movimento')"
                      @ordenar="aplicarOrdenacao('data_movimento', $event, `subMenuDataMov-${linha.uid}`)"
                  />
                </v-menu>
              </div>
            </th>
            <th class="subh-origem">
              <div class="subh-header-content">
                <div class="subh-inner justify-center">
                  <span class="subh-label">Origem</span>
                </div>
                <v-menu offset-y left :close-on-content-click="false" max-width="320" :ref="`subMenuOrigem-${linha.uid}`">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon x-small v-bind="attrs" v-on="on"
                        class="filter-btn filter-btn-subh"
                        :class="{ 'filter-active': filtrosProduto.origem.length > 0 || ordenacaoPorCampo.origem !== null }"
                    >
                      <v-icon x-small>mdi-filter-variant</v-icon>
                    </v-btn>
                  </template>
                  <filtro-coluna
                      campo="origem" tipo="selecao"
                      :valores="valoresUnicosProduto('origem')"
                      :filtro-ativo="filtrosProduto.origem"
                      :ordenacao-ativa="ordenacaoPorCampo.origem"
                      @aplicar="aplicarFiltroProduto('origem', $event, `subMenuOrigem-${linha.uid}`)"
                      @limpar="limparFiltroProduto('origem')"
                      @ordenar="aplicarOrdenacao('origem', $event, `subMenuOrigem-${linha.uid}`)"
                  />
                </v-menu>
              </div>
            </th>
            <th class="subh-val">
              <div class="subh-header-content">
                <div class="subh-inner justify-end">
                  <span class="subh-label">Solicitado</span>
                </div>
                <v-menu offset-y left :close-on-content-click="false" max-width="320" :ref="`subMenuCustoSolic-${linha.uid}`">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon x-small v-bind="attrs" v-on="on"
                        class="filter-btn filter-btn-subh"
                        :class="{ 'filter-active': filtrosProduto.custo_solicitado.min !== null || filtrosProduto.custo_solicitado.max !== null || ordenacaoPorCampo.custo_solicitado !== null }"
                    >
                      <v-icon x-small>mdi-filter-variant</v-icon>
                    </v-btn>
                  </template>
                  <filtro-coluna
                      campo="custo_solicitado" tipo="moeda"
                      :filtro-ativo="filtrosProduto.custo_solicitado"
                      :ordenacao-ativa="ordenacaoPorCampo.custo_solicitado"
                      @aplicar="aplicarFiltroProduto('custo_solicitado', $event, `subMenuCustoSolic-${linha.uid}`)"
                      @limpar="limparFiltroProduto('custo_solicitado')"
                      @ordenar="aplicarOrdenacao('custo_solicitado', $event, `subMenuCustoSolic-${linha.uid}`)"
                  />
                </v-menu>
              </div>
            </th>
            <th class="subh-val">
              <div class="subh-header-content">
                <div class="subh-inner justify-end">
                  <span class="subh-label">Atendido</span>
                </div>
                <v-menu offset-y left :close-on-content-click="false" max-width="320" :ref="`subMenuCustoAtend-${linha.uid}`">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon x-small v-bind="attrs" v-on="on"
                        class="filter-btn filter-btn-subh"
                        :class="{ 'filter-active': filtrosProduto.custo_atendido.min !== null || filtrosProduto.custo_atendido.max !== null || ordenacaoPorCampo.custo_atendido !== null }"
                    >
                      <v-icon x-small>mdi-filter-variant</v-icon>
                    </v-btn>
                  </template>
                  <filtro-coluna
                      campo="custo_atendido" tipo="moeda"
                      :filtro-ativo="filtrosProduto.custo_atendido"
                      :ordenacao-ativa="ordenacaoPorCampo.custo_atendido"
                      @aplicar="aplicarFiltroProduto('custo_atendido', $event, `subMenuCustoAtend-${linha.uid}`)"
                      @limpar="limparFiltroProduto('custo_atendido')"
                      @ordenar="aplicarOrdenacao('custo_atendido', $event, `subMenuCustoAtend-${linha.uid}`)"
                  />
                </v-menu>
              </div>
            </th>
            <th class="subh-val">
              <div class="subh-header-content">
                <div class="subh-inner justify-end">
                  <span class="subh-label">Não Atendido</span>
                </div>
                <v-menu offset-y left :close-on-content-click="false" max-width="320" :ref="`subMenuCustoFalt-${linha.uid}`">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon x-small v-bind="attrs" v-on="on"
                        class="filter-btn filter-btn-subh"
                        :class="{ 'filter-active': filtrosProduto.custo_faltante.min !== null || filtrosProduto.custo_faltante.max !== null || ordenacaoPorCampo.custo_faltante !== null }"
                    >
                      <v-icon x-small>mdi-filter-variant</v-icon>
                    </v-btn>
                  </template>
                  <filtro-coluna
                      campo="custo_faltante" tipo="moeda"
                      :filtro-ativo="filtrosProduto.custo_faltante"
                      :ordenacao-ativa="ordenacaoPorCampo.custo_faltante"
                      @aplicar="aplicarFiltroProduto('custo_faltante', $event, `subMenuCustoFalt-${linha.uid}`)"
                      @limpar="limparFiltroProduto('custo_faltante')"
                      @ordenar="aplicarOrdenacao('custo_faltante', $event, `subMenuCustoFalt-${linha.uid}`)"
                  />
                </v-menu>
              </div>
            </th>
            <th class="subh-pct">
              <div class="subh-header-content">
                <div class="subh-inner justify-center">
                  <span class="subh-label">% Atendido</span>
                </div>
                <v-menu offset-y left :close-on-content-click="false" max-width="320" :ref="`subMenuPctAtend-${linha.uid}`">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon x-small v-bind="attrs" v-on="on"
                        class="filter-btn filter-btn-subh"
                        :class="{ 'filter-active': filtrosProduto.percentual_atendido.min !== null || filtrosProduto.percentual_atendido.max !== null || ordenacaoPorCampo.percentual_atendido !== null }"
                    >
                      <v-icon x-small>mdi-filter-variant</v-icon>
                    </v-btn>
                  </template>
                  <filtro-coluna
                      campo="percentual_atendido" tipo="percentual"
                      :filtro-ativo="filtrosProduto.percentual_atendido"
                      :ordenacao-ativa="ordenacaoPorCampo.percentual_atendido"
                      @aplicar="aplicarFiltroProduto('percentual_atendido', $event, `subMenuPctAtend-${linha.uid}`)"
                      @limpar="limparFiltroProduto('percentual_atendido')"
                      @ordenar="aplicarOrdenacao('percentual_atendido', $event, `subMenuPctAtend-${linha.uid}`)"
                  />
                </v-menu>
              </div>
            </th>
            <th class="subh-status">
              <div class="subh-header-content">
                <div class="subh-inner justify-center">
                  <span class="subh-label">Status</span>
                </div>
                <v-menu offset-y left :close-on-content-click="false" max-width="320" :ref="`subMenuStatus-${linha.uid}`">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon x-small v-bind="attrs" v-on="on"
                        class="filter-btn filter-btn-subh"
                        :class="{ 'filter-active': filtrosProduto.status_principal.length > 0 || ordenacaoPorCampo.status_principal !== null }"
                    >
                      <v-icon x-small>mdi-filter-variant</v-icon>
                    </v-btn>
                  </template>
                  <filtro-coluna
                      campo="status_principal" tipo="selecao"
                      :valores="valoresUnicosProduto('status_principal')"
                      :filtro-ativo="filtrosProduto.status_principal"
                      :ordenacao-ativa="ordenacaoPorCampo.status_principal"
                      @aplicar="aplicarFiltroProduto('status_principal', $event, `subMenuStatus-${linha.uid}`)"
                      @limpar="limparFiltroProduto('status_principal')"
                      @ordenar="aplicarOrdenacao('status_principal', $event, `subMenuStatus-${linha.uid}`)"
                  />
                </v-menu>
              </div>
            </th>
          </tr>

          <tr
              v-if="linha.tipo === 'grupo'"
              :key="linha.uid"
              class="grupo-row"
              :class="`nivel-${linha.nivel}`"
              @click="$emit('toggle-expandido', linha.uid)"
          >
            <td class="td-exp">
              <div class="exp-inner" :style="{ paddingLeft: linha.nivel * 20 + 'px' }">
                <v-icon small color="#023449">
                  {{ expandidos.has(linha.uid) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                </v-icon>
              </div>
            </td>
            <td>
              <div class="nome-inner" :style="{ paddingLeft: linha.nivel * 20 + 'px' }">
                <v-icon small :color="dimStyle(linha.dim).color" class="mr-2">{{ dimStyle(linha.dim).icon }}</v-icon>
                <span class="nome-txt">{{ linha.nome }}</span>
                <v-chip x-small class="ml-2 chip-count" :color="dimStyle(linha.dim).chipBg" :text-color="dimStyle(linha.dim).chipTxt">
                  {{ linha.totalProdutos }} prod.
                </v-chip>
              </div>
            </td>
            <td class="text-center"><span class="badge-azul">{{ linha.skus_ativos }}</span></td>
            <td class="text-center">
              <span :class="linha.skus_ruptura > 0 ? 'badge-laranja' : 'badge-verde'">{{ linha.skus_ruptura }}</span>
            </td>
            <td class="text-right td-val">{{ fmt(linha.necessidade) }}</td>
            <td class="text-right"><span class="val-green">{{ fmt(linha.atendido) }}</span></td>
            <td class="text-right">
              <span v-if="linha.faltante > 0" class="val-red">{{ fmt(linha.faltante) }}</span>
              <span v-else class="val-zero">—</span>
            </td>
            <td class="text-center">
              <div class="pct-wrap">
                <span :class="pctCls(linha.pct_skus)">{{ fmtPct(linha.pct_skus) }}</span>
                <v-progress-linear :value="linha.pct_skus" :color="pctColor(linha.pct_skus)" background-color="#e2e8f0" height="3" rounded class="mt-1"/>
              </div>
            </td>
            <td class="text-center">
              <div class="pct-wrap">
                <span :class="pctCls(linha.pct_rs)">{{ fmtPct(linha.pct_rs) }}</span>
                <v-progress-linear :value="linha.pct_rs" :color="pctColor(linha.pct_rs)" background-color="#e2e8f0" height="3" rounded class="mt-1"/>
              </div>
            </td>
          </tr>

          <tr
              v-if="linha.tipo === 'produto'"
              :key="`p-${linha.uid}`"
              class="prod-row"
          >
            <td v-if="modoGrupos" class="td-exp"></td>
            <td>
              <div class="nome-inner" :style="{ paddingLeft: modoGrupos ? linha.nivel * 20 + 'px' : '0' }">
                <v-icon x-small color="#94a3b8" class="mr-1">mdi-package-variant-closed</v-icon>
                <div class="prod-info">
                  <span class="prod-cod">{{ linha.codigo }}</span>
                  <span class="prod-desc" :title="linha.descricao">{{ linha.descricao }}</span>
                  <div class="prod-ids">
                    <span class="prod-id-tag" title="ID Abastecimento">
                      <span class="prod-id-label">Lote:</span> {{ linha.id_abastecimento }}
                    </span>
                    <span v-if="linha.id_pedido" class="prod-id-tag prod-id-pedido" title="ID Pedido">
                      <span class="prod-id-label">Pedido:</span> {{ linha.id_pedido }}
                    </span>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center td-muted">{{ linha.data_mov }}</td>
            <td class="text-center td-origem">
              <v-chip
                  x-small
                  :color="getOrigemConfig(linha.origem).bg"
                  :text-color="getOrigemConfig(linha.origem).color"
                  class="chip-origem"
              >
                <v-icon x-small left :color="getOrigemConfig(linha.origem).color">
                  {{ getOrigemConfig(linha.origem).icon }}
                </v-icon>
                {{ getOrigemConfig(linha.origem).label }}
              </v-chip>
            </td>
            <td class="text-right td-val">{{ fmt(linha.custo_solicitado) }}</td>
            <td class="text-right"><span class="val-green">{{ fmt(linha.custo_atendido) }}</span></td>
            <td class="text-right">
              <span v-if="linha.custo_faltante > 0" class="val-red">{{ fmt(linha.custo_faltante) }}</span>
              <span v-else class="val-zero">—</span>
            </td>
            <td class="text-center">
              <div class="pct-wrap">
                <span :class="pctCls(100 - linha.pct_atendido)">{{ fmtPct(linha.pct_atendido) }}</span>
                <v-progress-linear
                    :value="linha.pct_atendido"
                    :color="linha.pct_atendido >= 100 ? '#16a34a' : linha.pct_atendido > 0 ? '#d97706' : '#dc2626'"
                    background-color="#e2e8f0" height="3" rounded class="mt-1"
                />
              </div>
            </td>
            <td class="text-center td-status-tags">
              <div class="status-tags-wrapper">
                <v-tooltip bottom max-width="280">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        x-small
                        v-bind="attrs"
                        v-on="on"
                        :color="getStatusConfig(linha.status_principal).bg"
                        :text-color="getStatusConfig(linha.status_principal).color"
                        class="chip-status-principal"
                    >
                      <v-icon x-small left :color="getStatusConfig(linha.status_principal).color">
                        {{ getStatusConfig(linha.status_principal).icon }}
                      </v-icon>
                      {{ getStatusConfig(linha.status_principal).label }}
                    </v-chip>
                  </template>
                  <div class="status-tooltip-content">
                    <div class="tooltip-header">{{ linha.status_principal }}</div>
                    <div v-if="linha.status_flags && temFlagsAtivas(linha.status_flags)" class="tooltip-flags">
                      <div v-if="linha.status_flags.inativo_compra" class="flag-item">
                        <v-icon x-small color="#f59e0b">mdi-cancel</v-icon>
                        <span>Produto inativo para compra</span>
                      </div>
                      <div v-if="linha.status_flags.est_max_zerado" class="flag-item">
                        <v-icon x-small color="#f59e0b">mdi-database-off</v-icon>
                        <span>Estoque máximo zerado</span>
                      </div>
                    </div>
                  </div>
                </v-tooltip>
              </div>
            </td>
          </tr>

          <tr
              v-if="linha.tipo === 'paginacao-grupo'"
              :key="`pg-${linha.uid}`"
              class="paginacao-grupo-row"
          >
            <td colspan="9">
              <div class="paginacao-inline" :style="{ paddingLeft: linha.nivel * 20 + 'px' }">
                <span class="pag-info">
                  Página <strong>{{ linha.pagina }}</strong> de <strong>{{ linha.totalPg }}</strong>
                  · {{ linha.total }} produtos
                </span>
                <div class="pag-btns">
                  <v-btn icon x-small :disabled="linha.pagina <= 1"
                         @click.stop="$emit('ir-para-pagina-grupo', linha.grupoUid, linha.pagina - 1)">
                    <v-icon x-small>mdi-chevron-left</v-icon>
                  </v-btn>
                  <template v-for="(p, pi) in paginasVisiveis(linha.pagina, linha.totalPg)">
                    <span v-if="p === '...'" :key="`el-${pi}`" class="pag-elipse">…</span>
                    <v-btn v-else :key="`pn-${pi}`"
                           x-small depressed
                           :color="p === linha.pagina ? '#023449' : ''"
                           :dark="p === linha.pagina"
                           class="pag-num-btn"
                           @click.stop="$emit('ir-para-pagina-grupo', linha.grupoUid, p)">
                      {{ p }}
                    </v-btn>
                  </template>
                  <v-btn icon x-small :disabled="linha.pagina >= linha.totalPg"
                         @click.stop="$emit('ir-para-pagina-grupo', linha.grupoUid, linha.pagina + 1)">
                    <v-icon x-small>mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </div>
            </td>
          </tr>

        </template>
        </tbody>
      </table>
    </div>

    <div v-if="!modoGrupos && totalPaginasFlat > 1" class="paginacao-flat">
      <span class="pag-info">
        Página <strong>{{ paginaFlat }}</strong> de <strong>{{ totalPaginasFlat }}</strong>
        · {{ totalProdutos }} produtos
      </span>
      <div class="pag-btns">
        <v-btn icon small :disabled="paginaFlat <= 1" @click="$emit('ir-para-pagina-flat', paginaFlat - 1)">
          <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        <template v-for="(p, pi) in paginasVisiveis(paginaFlat, totalPaginasFlat)">
          <span v-if="p === '...'" :key="`el-${pi}`" class="pag-elipse">…</span>
          <v-btn v-else :key="`pn-${pi}`"
                 small depressed
                 :color="p === paginaFlat ? '#023449' : ''"
                 :dark="p === paginaFlat"
                 class="pag-num-btn"
                 @click="$emit('ir-para-pagina-flat', p)">{{ p }}</v-btn>
        </template>
        <v-btn icon small :disabled="paginaFlat >= totalPaginasFlat" @click="$emit('ir-para-pagina-flat', paginaFlat + 1)">
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>

  </div>
</template>

<script>
import FiltroColuna from './FiltroColuna.vue';

export default {
  name: 'TabelaRupturas',

  components: {
    FiltroColuna,
  },

  props: {
    linhas: { type: Array, default: () => [] },
    modoGrupos: { type: Boolean, default: false },
    mapaGrupos: { type: Map, default: () => new Map() },
    expandidos: { type: Set, default: () => new Set() },
    loading: { type: Boolean, default: false },
    totalProdutos: { type: Number, default: 0 },
    paginaFlat: { type: Number, default: 1 },
    totalPaginasFlat: { type: Number, default: 1 },
    filtrosGrupo: { type: Object, default: () => ({}) },
    filtrosProduto: { type: Object, default: () => ({}) },
    ordenacaoPorCampo: { type: Object, default: () => ({}) },
    valoresUnicosGrupo: { type: Function, required: true },
    valoresUnicosProduto: { type: Function, required: true },
    dimensoes: { type: Object, required: true },
    fmt: { type: Function, required: true },
    fmtPct: { type: Function, required: true },
    pctColor: { type: Function, required: true },
    pctCls: { type: Function, required: true },
    statusLabel: { type: Function, required: true },
    statusColor: { type: Function, required: true },
  },

  data() {
    return {
      statusConfig: {
        'FORA DE LINHA': {
          icon: 'mdi-cancel',
          color: '#64748b',
          bg: '#f1f5f9',
          label: 'Fora de Linha'
        },
        'CORTADO - Sem Estoque CD': {
          icon: 'mdi-scissors-cutting',
          color: '#ea580c',
          bg: '#ffedd5',
          label: 'Cortado'
        },
        'RUPTURA TOTAL': {
          icon: 'mdi-alert-circle',
          color: '#dc2626',
          bg: '#fee2e2',
          label: 'Rupt. Total'
        },
        'RUPTURA PARCIAL': {
          icon: 'mdi-alert',
          color: '#ea580c',
          bg: '#ffedd5',
          label: 'Rupt. Parcial'
        },
        'Sugestão Ignorada': {
          icon: 'mdi-lightbulb-off-outline',
          color: '#4b5563',
          bg: '#dbeafe',
          label: 'Sug. Ignorada'
        },
        'ATENDIDO OK': {
          icon: 'mdi-check-circle',
          color: '#16a34a',
          bg: '#dcfce7',
          label: 'Atendido'
        },
      },

      origemConfig: {
        'SUGESTÃO': {
          icon: 'mdi-lightbulb-outline',
          color: '#ea580c',
          bg: '#ffedd5',
          label: 'Sugestão'
        },
        'PEDIDO': {
          icon: 'mdi-file-document-edit-outline',
          color: '#0284c7',
          bg: '#e0f2fe',
          label: 'Pedido'
        },
        'SUGESTÃO + PEDIDO': {
          icon: 'mdi-merge',
          color: '#059669',
          bg: '#d1fae5',
          label: 'Sug. + Ped.'
        },
      },
    };
  },

  methods: {
    dimStyle(dimKey) {
      return this.dimensoes[dimKey] || this.dimensoes.filial;
    },

    fecharMenu(menuRef) {
      this.$nextTick(() => {
        setTimeout(() => {
          const ref = this.$refs[menuRef];
          if (ref) {
            const menu = Array.isArray(ref) ? ref[0] : ref;
            if (menu && menu.isActive !== undefined) {
              menu.isActive = false;
            }
          }
        }, 150);
      });
    },

    aplicarFiltroGrupo(campo, valor, menuRef) {
      this.$emit('aplicar-filtro-grupo', campo, valor);
      if (menuRef) this.fecharMenu(menuRef);
    },

    limparFiltroGrupo(campo) {
      this.$emit('limpar-filtro-grupo', campo);
    },

    aplicarFiltroProduto(campo, valor, menuRef) {
      this.$emit('aplicar-filtro-produto', campo, valor);
      if (menuRef) this.fecharMenu(menuRef);
    },

    limparFiltroProduto(campo) {
      this.$emit('limpar-filtro-produto', campo);
    },

    aplicarOrdenacao(campo, direcao, menuRef) {
      this.$emit('ordenar', campo, direcao);
      if (menuRef) this.fecharMenu(menuRef);
    },

    paginasVisiveis(atual, total) {
      const janela = 2;
      const paginas = [];
      for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= atual - janela && i <= atual + janela)) {
          paginas.push(i);
        }
      }
      const resultado = [];
      for (let i = 0; i < paginas.length; i++) {
        if (i > 0 && paginas[i] - paginas[i - 1] > 1) resultado.push('...');
        resultado.push(paginas[i]);
      }
      return resultado;
    },

    valoresUnicosProdutoDoGrupo(grupoUid, campo) {
      const grupo = this.mapaGrupos.get(grupoUid);

      if (!grupo || !grupo.leafProds || grupo.leafProds.length === 0) {
        return [];
      }

      const valores = new Set();
      grupo.leafProds.forEach(produto => {
        if (produto[campo] !== null && produto[campo] !== undefined) {
          valores.add(produto[campo]);
        }
      });

      return Array.from(valores).sort();
    },

    getStatusConfig(statusText) {
      if (!statusText) {
        return {
          icon: 'mdi-help-circle',
          color: '#64748b',
          bg: '#f1f5f9',
          label: '?'
        };
      }

      if (this.statusConfig[statusText]) {
        return this.statusConfig[statusText];
      }

      return {
        icon: 'mdi-help-circle',
        color: '#64748b',
        bg: '#f1f5f9',
        label: statusText
      };
    },

    getOrigemConfig(origemText) {
      if (!origemText) {
        return {
          icon: 'mdi-help-circle',
          color: '#64748b',
          bg: '#f1f5f9',
          label: '?'
        };
      }

      if (this.origemConfig[origemText]) {
        return this.origemConfig[origemText];
      }

      return {
        icon: 'mdi-information-outline',
        color: '#64748b',
        bg: '#f1f5f9',
        label: origemText
      };
    },

    temFlagsAtivas(flags) {
      if (!flags) return false;
      return flags.inativo_compra || flags.est_max_zerado;
    },
  },
};
</script>

<style scoped>
.tabela-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(2,52,73,.04);
}

.estado-central {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  min-height: 280px; gap: 16px; color: #64748b; font-size: .875rem;
}

.table-wrapper { overflow-x: auto; }
.table-wrapper::-webkit-scrollbar { height: 5px; }
.table-wrapper::-webkit-scrollbar-thumb { background: rgba(2,52,73,.25); border-radius: 3px; }

.data-table {
  width: 100%; border-collapse: separate; border-spacing: 0; min-width: 980px;
  table-layout: fixed;
}

.col-exp    { width: 36px; }
.col-nome   { width: auto; min-width: 280px; }
.col-data   { width: 110px; }
.col-origem { width: 140px; }
.col-val    { width: 130px; }
.col-pct    { width: 120px; }
.col-status { width: 150px; }

.table-head-group { background: #012233; }
.table-head-group th {
  padding: 5px 12px;
  font-size: .625rem; font-weight: 700; letter-spacing: .8px;
  text-transform: uppercase; white-space: nowrap;
  border: none; vertical-align: middle;
}
.thg-empty { color: transparent; border: none !important; background: transparent; }
.thg-section {
  text-align: center;
  font-weight: 800;
  letter-spacing: 1px;
}
.thg-section-skus { background: #0e7490; color: #a5f3fc; }
.thg-section-financeiro { background: #065f46; color: #6ee7b7; }
.thg-section-ruptura { background: #9f1239; color: #fda4af; }

.table-head { background: #023449; }
.table-head th {
  padding: 7px 8px;
  font-size: .688rem; font-weight: 700;
  color: rgba(255,255,255,.85);
  text-transform: uppercase; letter-spacing: .5px;
  white-space: nowrap; border: none; vertical-align: middle;
  border-right: 1px solid rgba(255,255,255,.07);
  border-top: 1px solid rgba(255,255,255,.06);
}
.table-head th:last-child { border-right: none; }
.th-exp { width: 36px; padding: 0 !important; }

.th-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
  min-height: 28px;
}

.th-inner {
  display: flex; align-items: center; gap: 4px;
  flex: 1;
  min-width: 0;
}
.th-icon { opacity: .75; flex-shrink: 0; }

.indicadores-estado {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 4px;
}
.indicador-ordenacao {
  animation: fadeIn 0.3s ease-in;
}
.indicador-filtro {
  animation: fadeIn 0.3s ease-in;
}
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.8); }
  to { opacity: 1; transform: scale(1); }
}

.filter-btn {
  opacity: .4;
  transition: all .2s;
  flex-shrink: 0;
}
.filter-btn >>> .v-icon {
  color: rgba(255,255,255,0.6) !important;
}
.filter-btn:hover {
  opacity: 1;
  background: rgba(255,255,255,.15) !important;
}
.filter-btn.filter-active {
  opacity: 1;
  background: #7c3aed !important;
}
.filter-btn.filter-active >>> .v-icon {
  color: #ffffff !important;
}

.filter-btn-subh {
  opacity: .3;
  transition: all .2s;
}
.filter-btn-subh >>> .v-icon {
  color: rgba(2,52,73,0.5) !important;
}
.filter-btn-subh:hover {
  opacity: 1;
  background: rgba(2,52,73,.1) !important;
}
.filter-btn-subh.filter-active {
  opacity: 1;
  background: #7c3aed !important;
}
.filter-btn-subh.filter-active >>> .v-icon {
  color: #ffffff !important;
}

.th-nome   { text-align: left; }
.th-num    { text-align: center; }
.th-origem { text-align: center; }
.th-val    { text-align: right; }
.th-pct    { text-align: center; }
.th-status { text-align: center; }

.justify-start { justify-content: flex-start; }
.justify-center { justify-content: center; }
.justify-end { justify-content: flex-end; }

.subheader-row { background: #f0f7ff; border-top: none; border-bottom: 1px solid #bae6fd; }
.subheader-row th {
  padding: 5px 8px;
  font-size: .688rem; font-weight: 700;
  color: #023449;
  text-transform: uppercase; letter-spacing: .5px;
  white-space: nowrap; vertical-align: middle;
  border-right: 1px solid #dbeafe;
}
.subheader-row th:last-child { border-right: none; }

.subh-header-content {
  display: flex; align-items: center; justify-content: space-between;
  gap: 2px; min-height: 26px;
}
.subh-inner { display: flex; align-items: center; gap: 3px; flex: 1; min-width: 0; }
.subh-label { flex: 1; }

.subh-exp    { width: 36px; padding: 0 !important; border-right: none !important; }
.subh-nome   { text-align: left; }
.subh-num    { text-align: center; }
.subh-origem { text-align: center; }
.subh-val    { text-align: right; }
.subh-pct    { text-align: center; }
.subh-status { text-align: center; }

.grupo-row { cursor: pointer; border-bottom: 1px solid #f1f5f9; transition: background .12s; }
.grupo-row:hover { background: #f8fafc; }

.nivel-0 td { font-size: .875rem; font-weight: 700; }
.nivel-0     { border-left: 3px solid #023449; }
.nivel-1 td  { font-size: .813rem; font-weight: 600; background: #fafafa; }
.nivel-1     { border-left: 3px solid #7c3aed; }
.nivel-2 td  { font-size: .813rem; font-weight: 500; background: #fdfcfb; }
.nivel-2     { border-left: 3px solid #c2410c; }

.grupo-row td { padding: 10px 14px; color: #334155; vertical-align: middle; }

.prod-row { border-bottom: 1px solid #f8fafc; transition: background .1s; }
.prod-row:hover { background: #fefce8; }
.prod-row td { padding: 7px 14px; vertical-align: middle; }

.td-exp  { width: 40px; padding: 0 6px !important; }
.td-val  { font-weight: 600; color: #334155; font-size: .875rem; }
.td-muted { font-size: .75rem; color: #64748b; }
.td-origem { padding: 4px 8px !important; }

.exp-inner, .nome-inner { display: flex; align-items: center; }

.nome-txt {
  font-weight: inherit; color: #023449;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 280px;
}

.chip-count  { font-size: .625rem !important; font-weight: 700 !important; height: 18px !important; flex-shrink: 0; }

.prod-info { display: flex; flex-direction: column; min-width: 0; gap: 1px; }
.prod-cod  { font-family: monospace; font-size: .688rem; font-weight: 700; color: #64748b; }
.prod-desc { font-size: .75rem; font-weight: 500; color: #334155; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 340px; }

.prod-ids { display: flex; align-items: center; gap: 8px; margin-top: 2px; }

.prod-id-tag {
  display: inline-flex; align-items: center; gap: 2px;
  font-family: monospace; font-size: .625rem; font-weight: 600;
  color: #94a3b8; background: #f1f5f9;
  border: 1px solid #e2e8f0; border-radius: 4px;
  padding: 1px 5px; white-space: nowrap; line-height: 1.4;
}

.prod-id-label { font-weight: 700; opacity: .7; margin-right: 1px; }
.prod-id-pedido { color: #7c3aed; background: #f5f3ff; border-color: #ddd6fe; }

.badge-azul, .badge-laranja, .badge-verde {
  display: inline-block; padding: 2px 8px; border-radius: 5px;
  font-weight: 700; font-size: .813rem;
}
.badge-azul    { background: #e0f2fe; color: #0c4a6e; }
.badge-laranja { background: #ffedd5; color: #c2410c; }
.badge-verde   { background: #d1fae5; color: #047857; }

.val-green { font-weight: 700; color: #047857; font-size: .875rem; }
.val-red   { font-weight: 700; color: #b91c1c; font-size: .875rem; }
.val-zero  { color: #94a3b8; font-size: .875rem; }

.pct-wrap  { display: flex; flex-direction: column; align-items: center; min-width: 58px; }
.pct-high  { font-weight: 700; font-size: .813rem; color: #dc2626; }
.pct-med   { font-weight: 700; font-size: .813rem; color: #ea580c; }
.pct-low   { font-weight: 700; font-size: .813rem; color: #d97706; }
.pct-ok    { font-weight: 700; font-size: .813rem; color: #16a34a; }

.chip-origem {
  font-size: .688rem !important;
  font-weight: 700 !important;
  height: 24px !important;
  padding: 0 10px !important;
  border-radius: 6px !important;
  letter-spacing: .2px !important;
  border: 1px solid currentColor !important;
  opacity: 0.9;
  transition: all 0.2s;
}

.chip-origem:hover {
  opacity: 1;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.chip-origem >>> .v-chip__content {
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
}

.chip-origem >>> .v-icon {
  margin-right: 0 !important;
  margin-left: 0 !important;
  font-size: 14px !important;
}

.td-status-tags {
  padding: 4px 8px !important;
}

.status-tags-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 110px;
}

.chip-status-principal {
  font-size: .688rem !important;
  font-weight: 700 !important;
  height: 22px !important;
  padding: 0 8px !important;
  border-radius: 6px !important;
  letter-spacing: .2px !important;
  border: 1px solid currentColor !important;
  opacity: 0.9;
  cursor: help;
}

.chip-status-principal >>> .v-chip__content {
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
}

.chip-status-principal >>> .v-icon {
  margin-right: 0 !important;
  margin-left: 0 !important;
  font-size: 14px !important;
}

.status-tooltip-content {
  padding: 4px;
}

.tooltip-header {
  font-weight: 700;
  font-size: .75rem;
  color: #fff;
  margin-bottom: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(255,255,255,0.2);
}

.tooltip-flags {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.flag-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: .688rem;
  color: #fff;
  padding: 2px 0;
}

.flag-item >>> .v-icon {
  flex-shrink: 0;
}

.chip-status-principal,
.chip-origem {
  animation: fadeInStatus 0.3s ease-out;
}

@keyframes fadeInStatus {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.paginacao-grupo-row { background: #f8fafc; border-bottom: 1px solid #e2e8f0; }
.paginacao-grupo-row td { padding: 6px 14px; }

.paginacao-inline, .paginacao-flat {
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px;
}

.paginacao-flat {
  padding: 12px 20px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.pag-info { font-size: .813rem; color: #64748b; font-weight: 500; }
.pag-info strong { color: #023449; font-weight: 700; }

.pag-btns { display: flex; align-items: center; gap: 4px; }

.pag-elipse {
  display: inline-flex; align-items: center; justify-content: center;
  width: 28px; height: 28px; font-size: .875rem; color: #94a3b8; font-weight: 700;
}

.pag-num-btn {
  min-width: 30px !important; height: 28px !important;
  font-size: .75rem !important; font-weight: 700 !important;
  border-radius: 6px !important; padding: 0 6px !important;
  text-transform: none !important;
}

.text-center { text-align: center !important; }
.text-right  { text-align: right  !important; }
.mr-1        { margin-right: 4px; }
.mr-2        { margin-right: 8px; }
.ml-2        { margin-left: 8px; }
.mt-1        { margin-top: 4px; }
</style>